import { createContext } from "react";

const UploadRoutineContext = createContext();

export default UploadRoutineContext;